module.exports = __webpack_public_path__ + "static/img/bg.1f202db7.png";